import { useSyncExternalStore } from 'react';
import { Link, useInRouterContext, useLocation } from 'react-router-dom';
import { Alert } from '../../atoms/Alert/Alert';
import { useTranslation } from '../../../i18n/useTranslation';
import { isLicenseRequired, subscribeLicenseRequired } from '../../../lib/licenseStatus';
import './LicenseRequiredNotice.css';

/** Route of the licence page (pages/Settings/LicensePage.tsx). */
export const LICENSE_PAGE_PATH = '/settings/license';

function LicensePageLink() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  if (pathname === LICENSE_PAGE_PATH) return null;
  return (
    <Link to={LICENSE_PAGE_PATH} className="rg-license-notice__link">
      {t('license.manageLink')}
    </Link>
  );
}

/**
 * Shown above the page content once the API has answered 403
 * LICENSE_REQUIRED: tells the user their (beta) access is not active and
 * links to the licence page, where they can see why and activate a licence
 * key. Renders nothing otherwise.
 */
export function LicenseRequiredNotice() {
  const { t } = useTranslation();
  const inRouter = useInRouterContext();
  const required = useSyncExternalStore(subscribeLicenseRequired, isLicenseRequired, isLicenseRequired);

  if (!required) return null;

  return (
    <Alert
      tone="warning"
      title={t('license.betaInactiveTitle')}
      className="rg-license-notice"
      data-testid="license-required-notice"
      action={inRouter ? <LicensePageLink /> : undefined}
    >
      {t('license.betaInactiveMessage')}
    </Alert>
  );
}

export default LicenseRequiredNotice;
